/* ========================================================================== */
/* File: src/pages/ResetPasswordPage.js (Corrected with UX Fixes)      */
/* ========================================================================== */
import React, { useState } from 'react';
import { api } from '../api'; 
import '../styles/Auth.css';

const ResetPasswordPage = ({ token }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const data = await api.resetPassword(token, password);
            // Updated success message for clarity
            setMessage('Password has been reset successfully. Please log in.');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="landing-page">
            <div className="auth-card">
                {/* --- FIX 1: Only show header and form if there is no success message --- */}
                {!message && (
                    <>
                        <div className="auth-header">
                            <h1>Choose a New Password</h1>
                        </div>
                        {error && <div className="error-message">{error}</div>}
                        <form className="auth-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label className="form-label" htmlFor="new-password">New Password</label>
                                <input id="new-password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-input" required disabled={loading} />
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="confirm-password">Confirm New Password</label>
                                <input id="confirm-password" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="form-input" required disabled={loading} />
                            </div>
                            <button type="submit" className="form-button" disabled={loading}>
                                {loading ? 'Resetting...' : 'Reset Password'}
                            </button>
                        </form>
                    </>
                )}

                {/* --- FIX 2: Show success message and a link to login --- */}
                {message && (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{color: 'green', backgroundColor: '#dcfce7', padding: '0.75rem', borderRadius: '0.375rem', fontSize: '0.875rem', marginBottom: '1rem'}}>
                            {message}
                        </div>
                        <a href="/" className="form-button" style={{ textDecoration: 'none', display: 'inline-block' }}>
                            Go to Login
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResetPasswordPage;